import React from 'react'
import { Container, Col, Row, Form, Card, Button, InputGroup } from 'react-bootstrap'
import { useFormik } from 'formik'
import * as yup from 'yup' // for everything
import { connect } from 'react-redux'
import { RootState, AppDispatch, updatePriceControls } from '../store'

const schema = yup.object({
  catMasterPriceModifier: yup.string().required('Required').typeError('Must be a number'),
})

type AdminControlsProps = {
  updatePriceControls: (body: any) => void
  controls: { catMasterPriceModifier: number }
}

const AdminControls = ({ updatePriceControls, controls }: AdminControlsProps) => {
  const formik = useFormik({
    initialValues: {
      catMasterPriceModifier: controls.catMasterPriceModifier || '',
    },
    enableReinitialize: true,
    validationSchema: schema,
    onSubmit: (values) => {
      updatePriceControls(values)
    },
  })

  return (
    <Container fluid>
      <Card className="mt-3">
        <Card.Header>
          <h3>Admin Controls</h3>
        </Card.Header>
        <Card.Body>
          <Form noValidate onSubmit={formik.handleSubmit}>
            <Row>
              <Col xs={6} style={{ margin: 0 }}>
                <Form.Label style={{ fontWeight: '600' }}>
                  Set value for universal cat price increase or reduction, doesn&apos;t affect
                  metals
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="catMasterPriceModifier"
                    value={formik.values.catMasterPriceModifier}
                    placeholder="-10 or 10"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    isValid={
                      formik.touched.catMasterPriceModifier && !formik.errors.catMasterPriceModifier
                    }
                  />
                  <InputGroup.Text>%</InputGroup.Text>
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  {formik.errors.catMasterPriceModifier}
                </Form.Control.Feedback>
              </Col>
            </Row>
          </Form>
          <Row className="mt-3">
            <Col xs={6}>
              <Button onClick={() => formik.submitForm()} style={{ width: `100%` }}>
                Update Prices
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  )
}

const mapState = (state: RootState) => {
  return {
    controls: state.admin.controls,
  }
}

const mapDispatch = (dispatch: AppDispatch) => {
  return {
    updatePriceControls(body: { catMasterPriceModifier: number }) {
      dispatch(updatePriceControls(body))
    },
  }
}

const Connected = connect(mapState, mapDispatch)(AdminControls)

export default Connected
